export default __webpack_public_path__ + "static/image-63-6f29546cbc3f0b8ced96ae0409554a6f.jpg";